import { isDate, format, parseISO } from 'date-fns'
export default {
  validate(value) {
    const enteredDate = format(value, 'dd/MM/yyyy')
    return isDate(parseISO(enteredDate))
  },
}
